const StreamingTransactionTypes: any = {
  ALL: {
    description: 'All streaming transactions',
    value: 'KASASA_STREAMING_REWARD',
  },
  VIDEO_STREAMING: {
    description: 'Video streaming purchases only',
    value: 'VIDEO_STREAMING',
  },
  AUDIO_STREAMING: {
    description: 'Audio streaming purchases only',
    value: 'AUDIO_STREAMING',
  },
  GAMING_STREAMING: {
    description: 'Gaming streaming purchases only',
    value: 'GAMING_STREAMING',
  },
  VIDEO_AUDIO_STREAMING: {
    description: 'Video and audio streaming purchases only',
    value: 'VIDEO_AUDIO_STREAMING',
  },
  VIDEO_GAMING_STREAMING: {
    description: 'Video and gaming streaming purchases only',
    value: 'VIDEO_GAMING_STREAMING',
  },
  AUDIO_GAMING_STREAMING: {
    description: 'Audio and gaming streaming purchases only',
    value: 'AUDIO_GAMING_STREAMING',
  },
};

export default StreamingTransactionTypes;
